import HtmlParser from 'html-react-parser';
import React from 'react';
import Helmet from 'react-helmet';
import { Link } from 'react-scroll';
import { DemoFormLong } from '../../components/DemoFormLong.jsx';
import SEO from '../../components/SEO';
import Layout from '../../layouts/index';

const Home = (props) => {
	const location = props.location;

	return (
		<Layout bodyClass="page-media" ontouchstart>
			<SEO title="Media Kit | ChartHop | The Org Management Platform" />
			<Helmet>
				<meta
					name="description"
					content="Download official ChartHop logos, headshots and more. Logos in svg and png available here."
				/>
				<meta property="og:url" content={`https://www.charthop.com${location.pathname}`} />
				<meta property="og:title" content="Media Kit | ChartHop | The Org Management Platform" />
				<meta property="og:description" content="Download official ChartHop logos, headshots and more. Logos in svg and png available here." />
				<meta property="og:image" content={`https://www.charthop.com/home/charthop-facebook.png`} />
				<meta property="og:type" content="website" />
				<meta property="og:locale" content="en_US" />
        		<meta property="og:site_name" content="ChartHop" />
				{/* Twitter Card tags */}
				<meta name="twitter:title" content="Media Kit | ChartHop | The Org Management Platform" />
				<meta name="twitter:description" content="Download official ChartHop logos, headshots and more. Logos in svg and png available here." />
				<meta name="twitter:image" content={`https://www.charthop.com/home/charthop-twitter.jpg`} />
				<meta name="twitter:card" content="summary_large_image" />
				<meta name="twitter:site" content="@charthop" />
                <meta name="twitter:creator" content="@charthop" />

			</Helmet>

			{/* HERO CONTENT */}
			<section className="heroMedia">
				<div className="row sectionSpacing contentBlock">
					<div className="col-md-6 col-sm-12 text-center text-md-left">
						<h1>ChartHop Media Kit</h1>						
						<p className="my-2">Download official ChartHop logos, platform shots, and team photos.</p>
						<p> For media inquiries contact <a href="mailto:marketing@charthop.com" rel="noopener noreferrer" target="_blank">marketing@charthop.com</a>.</p>
						<div>
							<a href="https://drive.google.com/open?id=1EE0AQgoevb8dRMDufiXN6rzDWr0n7NC9" rel="noopener noreferrer" target="_blank" className="button my-2">DOWNLOAD FULL MEDIA KIT</a>
						</div>
					</div>
				</div>
			</section>

			{/* INLINE PAGE NAVIGATION */}
			<section className="subNavigationMenu-Inline">
				<div>
					<div>
						<div>
							<Link to="Logo" smooth={true} offset={-70} duration={500}>Logo</Link>
						</div>
						<div>/</div>
						<div>
							<Link to="Screenshots" smooth={true} offset={-70} duration={500}>Platform Shots</Link>
						</div>
						<div>/</div>
						<div>
							<Link to="Team" smooth={true} offset={-70} duration={500}>Team</Link>
						</div>
						
					</div>
				</div>
			</section>

			{/* LOGOS */}		
			<section className="sectionSpacing flex-centeredColumn" id="Logo">				
				<h2 className="text-center centerSpacing">Logo</h2>	
				<div className="contentBlock d-flex justify-content-between flex-wrap gridContainer mb-5 mt-1">
					<div className="logoTitle">
						<h3>Large Usage</h3>
						<p>Use for applications <br></br>
						<strong>larger than 140 pixels wide</strong></p>
					</div>
					<div className="threeQuartersCard bgGrey">
						<div className="logoBox logo100 text-center">							
							<img src={'/media/svg/charthop-logo1.svg'} alt="ChartHop Logo" />
							<div className="primary-overlay"></div>
							<div className="formats">
								<ul>
									<li><a target="_blank" rel="noopener noreferrer" href={'/media/png/charthop-logo1.png'}>.png</a></li>
									<li><a target="_blank" rel="noopener noreferrer" href={'/media/jpg/charthop-logo1.jpg'}>.jpg</a></li>
									<li><a target="_blank" rel="noopener noreferrer" href={'/media/svg/charthop-logo1.svg'}>.svg</a></li>
									<li><a target="_blank" rel="noopener noreferrer" href={'/media/gif/charthop-logo-animated.gif'}>.gif</a></li>
								</ul>
							</div>
						</div>
						<div className="logoBox logo50 bgCian text-center">
							<img src={'/media/svg/charthop-logo2.svg'} alt="ChartHop Logo" />
							<div className="primary-overlay"></div>
							<div className="formats">
								<ul>
									<li><a target="_blank" rel="noopener noreferrer" href={'/media/png/charthop-logo2.png'}>.png</a></li>									
									<li><a target="_blank" rel="noopener noreferrer" href={'/media/svg/charthop-logo2.svg'}>.svg</a></li>
								</ul>
							</div>
						</div>
						<div className="logoBox logo50 bgBlue text-center">
							<img src={'/media/svg/charthop-logo3.svg'} alt="ChartHop Logo" />
							<div className="primary-overlay"></div>
							<div className="formats">
								<ul>
									<li><a target="_blank" rel="noopener noreferrer" href={'/media/png/charthop-logo3.png'}>.png</a></li>
									<li><a target="_blank" rel="noopener noreferrer" href={'/media/svg/charthop-logo3.svg'}>.svg</a></li>
								</ul>
							</div>
						</div>	
						<div className="logoBox logo50 bgWhite text-center">
							<img src={'/media/svg/charthop-logo-black.svg'} alt="ChartHop Logo" />
							<div className="primary-overlay"></div>
							<div className="formats">
								<ul>
									<li><a target="_blank" rel="noopener noreferrer" href={'/media/png/charthop-logo-black.png'}>.png</a></li>	
									<li><a target="_blank" rel="noopener noreferrer" href={'/media/jpg/charthop-logo-black.jpg'}>.jpg</a></li>									
									<li><a target="_blank" rel="noopener noreferrer" href={'/media/svg/charthop-logo-black.svg'}>.svg</a></li>
								</ul>
							</div>
						</div>
						<div className="logoBox logo50 bgBlack text-center">
							<img src={'/media/svg/charthop-logo-white.svg'} alt="ChartHop Logo" />
							<div className="primary-overlay"></div>
							<div className="formats">
								<ul>
									<li><a target="_blank" rel="noopener noreferrer" href={'/media/png/charthop-logo-white.png'}>.png</a></li>
									<li><a target="_blank" rel="noopener noreferrer" href={'/media/svg/charthop-logo-white.svg'}>.svg</a></li>
								</ul>
							</div>
						</div>											
					</div>
				</div>
				<div className="contentBlock d-flex justify-content-between flex-wrap gridContainer mb-4 mt-1">
					<div className="logoTitle">
						<h3>Small Usage</h3>
						<p>Use for applications <br></br>
						<strong>less than 140 pixels wide</strong></p>
					</div>
					<div className="threeQuartersCard bgGrey">
						<div className="logoBox logo20 text-center">							
							<img src={'/media/svg/charthop-logo-small-1.svg'} alt="ChartHop Logo" />
							<div className="primary-overlay"></div>
							<div className="formats">
								<ul>
									<li><a target="_blank" rel="noopener noreferrer" href={'/media/png/charthop-logo-small-1.png'}>.png</a></li>
									<li><a target="_blank" rel="noopener noreferrer" href={'/media/jpg/charthop-logo-small-1.jpg'}>.jpg</a></li>
									<li><a target="_blank" rel="noopener noreferrer" href={'/media/svg/charthop-logo-small-1.svg'}>.svg</a></li>
								</ul>
							</div>
						</div>
						<div className="logoBox logo20 bgCian text-center">
							<img src={'/media/svg/charthop-logo-small-2.svg'} alt="ChartHop Logo" />
							<div className="primary-overlay"></div>
							<div className="formats">
								<ul>
									<li><a target="_blank" rel="noopener noreferrer" href={'/media/png/charthop-logo-small-2.png'}>.png</a></li>
									<li><a target="_blank" rel="noopener noreferrer" href={'/media/svg/charthop-logo-small-2.svg'}>.svg</a></li>									
								</ul>
							</div>
						</div>
						<div className="logoBox logo20 bgBlue text-center">
							<img src={'/media/svg/charthop-logo-small-3.svg'} alt="ChartHop Logo" />
							<div className="primary-overlay"></div>
							<div className="formats">
								<ul>
									<li><a target="_blank" rel="noopener noreferrer" href={'/media/png/charthop-logo-small-3.png'}>.png</a></li>
									<li><a target="_blank" rel="noopener noreferrer" href={'/media/svg/charthop-logo-small-3.svg'}>.svg</a></li>									
								</ul>
							</div>
						</div>
						<div className="logoBox logo20 bgWhite text-center">
							<img src={'/media/svg/charthop-logo-small-black.svg'} alt="ChartHop Logo" />
							<div className="primary-overlay"></div>
							<div className="formats">
								<ul>
									<li><a target="_blank" rel="noopener noreferrer" href={'/media/png/charthop-logo-small-black.png'}>.png</a></li>	
									<li><a target="_blank" rel="noopener noreferrer" href={'/media/jpg/charthop-logo-small-black.jpg'}>.jpg</a></li>									
									<li><a target="_blank" rel="noopener noreferrer" href={'/media/svg/charthop-logo-small-black.svg'}>.svg</a></li>									
								</ul>
							</div>
						</div>
						<div className="logoBox logo20 bgBlack text-center">
							<img src={'/media/svg/charthop-logo-small-white.svg'} alt="ChartHop Logo" />
							<div className="primary-overlay"></div>
							<div className="formats">
								<ul>
									<li><a target="_blank" rel="noopener noreferrer" href={'/media/png/charthop-logo-small-white.png'}>.png</a></li>
									<li><a target="_blank" rel="noopener noreferrer" href={'/media/svg/charthop-logo-small-white.svg'}>.svg</a></li>									
								</ul>
							</div>
						</div>												
					</div>
				</div>
				<div className="contentBlock d-flex justify-content-between flex-wrap gridContainer mb-4 mt-1">
					<div className="logoTitle">
						<h3>ChartHop Bunny</h3>
						<p>Use as favicon</p>
					</div>
					<div className="threeQuartersCard bgGrey">
						<div className="logoBox bunny text-center">							
							<img src={'/media/svg/charthop-bunny-blue.svg'} alt="ChartHop Logo" />
							<div className="primary-overlay"></div>
							<div className="formats">
								<ul>
									<li><a target="_blank" rel="noopener noreferrer" href={'/media/png/charthop-bunny-blue.png'}>.png</a></li>
									<li><a target="_blank" rel="noopener noreferrer" href={'/media/jpg/charthop-bunny-blue.jpg'}>.jpg</a></li>
									<li><a target="_blank" rel="noopener noreferrer" href={'/media/svg/charthop-bunny-blue.svg'}>.svg</a></li>									
								</ul>
							</div>
						</div>
						<div className="logoBox bunny bgCian text-center">
							<img src={'/media/svg/charthop-bunny-white.svg'} alt="ChartHop Logo" />
							<div className="primary-overlay"></div>
							<div className="formats">
								<ul>
									<li><a target="_blank" rel="noopener noreferrer" href={'/media/png/charthop-bunny-white.png'}>.png</a></li>
									<li><a target="_blank" rel="noopener noreferrer" href={'/media/svg/charthop-bunny-white.svg'}>.svg</a></li>									
								</ul>
							</div>
						</div>									
					</div>
				</div>					
				<div className="text-center">
					<a href="https://drive.google.com/open?id=1pwGiVnxL3Ep3dIJhKZYHCvws5ykJBd_c" rel="noopener noreferrer" target="_blank" className="button mb-2 mt-1">DOWNLOAD ALL LOGOS</a>
				</div>				
			</section>

			{/* PLATFORM */}
            <section className="text-center sectionSpacing flex-centeredColumn media-trio backgroundGradientContainer-Reverse" id="Screenshots">                
                <h2 className="text-center centerSpacing">Platform Shots</h2>
                <div className="contentBlock d-flex justify-content-between flex-wrap gridContainer">
                    <div className="verticalThird mb-0">
						<a href="https://drive.google.com/open?id=1EgdwHg5kOecZ65dOO69HrddQeMbxI0wF" rel="noopener noreferrer" target="_blank" >
                            <div class="media-trio-item">
                                <div class="icon">
                                    <img src={'/media/download.svg'} alt="download icon"/>
                                </div>
                                <div class="image-card platform-images"></div>
                            </div>
                        </a>
                        <div class="media-trio-text">
							<h3>Platform Images</h3>
							<p>Download them in <a href="https://drive.google.com/open?id=1EgdwHg5kOecZ65dOO69HrddQeMbxI0wF" rel="noopener noreferrer" target="_blank" >png</a>.</p>
                        </div>              
                    </div>
                    <div className="verticalThird mb-0">
                        <a href="https://drive.google.com/open?id=1EijVCeXFZzcvO4_nND1qoCwEZ4SJrefh" target="_blank">
                            <div class="media-trio-item">
                                <div class="icon">
                                    <img src={'/media/download.svg'} alt="download icon"/>
                                </div>
                                <div class="image-card platform-animations"></div>
                            </div>
                        </a>
                        <div class="media-trio-text">
							<h3>Platform Animations</h3>
							<p>Download them in <a href="https://drive.google.com/open?id=1El9W6QXRfu-XMUuOpQdEItaw8aszLp2a" rel="noopener noreferrer" target="_blank" >video</a> or <a href="https://drive.google.com/open?id=1EijVCeXFZzcvO4_nND1qoCwEZ4SJrefh" rel="noopener noreferrer" target="_blank" >gif</a>.</p>
                        </div>                                        
                    </div>
                    <div className="verticalThird mb-0">
                        <a href="https://www.youtube.com/channel/UCiC6zx3_KlEuqXdu2VDmHaA" target="_blank">
                            <div class="media-trio-item">
                                <div class="icon">
                                    <img src={'/press/play.svg'} alt="play icon"/>
                                </div>
                                <div class="image-card promo-videos"></div>
                            </div>
                        </a>
                        <div class="media-trio-text">
							<h3>Promo Videos</h3>
							<p>Access videos on <a href="https://www.youtube.com/channel/UCiC6zx3_KlEuqXdu2VDmHaA" rel="noopener noreferrer" target="_blank" >YouTube</a>.</p>
                        </div>                                                                       
                    </div> 
                </div>
				<div className="flex-centeredColumn">
					<a href="https://drive.google.com/open?id=1ENKaWkTU5Btu1OPz2BqejnFsnSVneOlK" rel="noopener noreferrer" target="_blank" className="button mb-2 mt-5">DOWNLOAD ALL PLATFORM SHOTS</a>
				</div>                
            </section>

			{/* TEAM */}
            <section className="text-center sectionSpacing flex-centeredColumn media-trio" id="Team">                
                <h2 className="text-center centerSpacing">Team</h2>
                <div className="contentBlock d-flex justify-content-between flex-wrap gridContainer">
                    <div className="verticalThird backgroundGradientContainer-Reverse mb-0">
						<a href="/media/team/charthop-ian-white-ceo.jpg" rel="noopener noreferrer" target="_blank" >
                            <div class="media-trio-item">
                                <div class="icon">
                                    <img src={'/media/download.svg'} alt="download icon"/>
                                </div>
                                <div class="image-card ian-white-ceo"></div>
                            </div>
                        </a>
                        <div class="media-trio-text">
							<h3>Founder & CEO/CTO</h3>
							<p>Download <a href="/media/team/charthop-ian-white-ceo.jpg" rel="noopener noreferrer" target="_blank" >headshot</a> of Ian White, Founder & CEO/CTO.</p>
                        </div>              
                    </div>
                    <div className="verticalThird backgroundGradientContainer-Reverse mb-0">
                        <a href="https://drive.google.com/open?id=1E_2IXvrL387Jg_8o12OXw9fgUguVN6lG" target="_blank">
                            <div class="media-trio-item">
                                <div class="icon">
                                    <img src={'/media/download.svg'} alt="download icon"/>
                                </div>
                                <div class="image-card team-org"></div>
                            </div>
                        </a>
                        <div class="media-trio-text">
							<h3>Team Org Chart</h3>
							<p>Download different ChartHop visualizations of our team <a href="https://drive.google.com/open?id=1E_2IXvrL387Jg_8o12OXw9fgUguVN6lG" rel="noopener noreferrer" target="_blank" >here</a>.</p>
                        </div>                                        
                    </div>
                    <div className="verticalThird backgroundGradientContainer-Reverse mb-0">
                        <a href="https://drive.google.com/open?id=1E_dP_73WTVvstwKTLMDVaEnNvDbBbHRU" target="_blank">
                            <div class="media-trio-item">
                                <div class="icon">
                                    <img src={'/media/download.svg'} alt="download icon"/>
                                </div>
                                <div class="image-card team-photos"></div>
                            </div>
                        </a>
                        <div class="media-trio-text">
							<h3>Team Photos</h3>
							<p >Download miscelanous photos of our team <a href="https://drive.google.com/open?id=1E_dP_73WTVvstwKTLMDVaEnNvDbBbHRU" rel="noopener noreferrer" target="_blank" >here</a>.</p>
                        </div>                                                                       
                    </div> 
                </div>
				<div className="flex-centeredColumn">
					<a href="https://drive.google.com/open?id=1EIM-ZcW_D4VQdYMgTizS9gnwzAUNrgWb" rel="noopener noreferrer" target="_blank" className="button mb-2 mt-5">DOWNLOAD ALL TEAM PHOTOS</a>
				</div>                
            </section>
		

			{/* CTA */}
			<section className="backgroundGradientContainer sectionSpacing sectionSpacingCenter">
				<div className="textContent">
					<img src={'/home/bunny.svg'} alt="ChartHop logo" />
					<div>
						<p>Download official ChartHop logos, platform shots, and team photos.</p>
					</div>
				</div>
				<div className="buttonContent">
					<a className="button my-2" rel="noopener noreferrer" target="_blank" href="https://drive.google.com/open?id=1EE0AQgoevb8dRMDufiXN6rzDWr0n7NC9">DOWNLOAD FULL MEDIA KIT</a>
				</div>
			</section>

			{/* LONG FORM */}
			<section name="request-demo" id="request-demo" className="request-demo sectionSpacing">
                <DemoFormLong source={"company-media-demo-bottom"} headertext={HtmlParser("<h2>We'd love to show you what we're building.<br/><br/>Request a demo!</h2>")}/>
            </section>

		</Layout>
	);
};


export default Home;